module.exports = __webpack_public_path__ + "static/media/Project1_Fig11.8655e0d3.svg";